class CookieBanner {
  constructor(cookieConsent) {
    this.cookieConsent = cookieConsent;
    this.init();
  }

  init() {
    // Cache DOM elements
    this.$container = jQuery(".mad-cookie-banner__container");
    this.$acceptAllButton = this.$container.find(
      ".mad-cookie-banner__button--accept-all"
    );
    this.$denyAllButton = this.$container.find(
      ".mad-cookie-banner__button--deny-all"
    );
    this.$customizeButton = this.$container.find(
      ".mad-cookie-banner__button--customize"
    );

    // Bind event handlers
    this.bindEvents();
  }

  bindEvents() {
    this.$acceptAllButton.on("click", () => {
      this.onAcceptAll();
    });

    this.$denyAllButton.on("click", () => {
      this.onDenyAll();
    });

    this.$customizeButton.on("click", () => {
      this.onCustomize();
    });
  }

  onAcceptAll() {
    // Delegate consent granting to CookieConsent
    this.cookieConsent.acceptAll();
  }
  onDenyAll() {
    // Delegate consent denial to CookieConsent
    this.cookieConsent.denyAll();
  }

  onCustomize() {
    // Show the modal through CookieModal
    this.cookieConsent.modal.show();
  }

  show() {
    this.$container.show();
  }

  hide() {
    this.$container.hide();
  }
}

module.exports = CookieBanner;
